export default {
  reinstatements: "reinstatements",
  REINSTATEMENT_PROFORMA: (code) =>
    `cu/PEGASUS_CU/SchoolManagement_getRestatementProformaInvoice?applicationCode=${code}`,
};
